import styles from "./BlankFrame.module.css";
import React from "react";

function BlankFrame({ children }) {
  return (
    <section className={styles.blankFrame}>
      <div>
        <h2>{children}</h2>
      </div>
    </section>
  );
}

export default BlankFrame;
